var map = {
	"./barometer.svg": 4125,
	"./celsius.svg": 7196,
	"./clear-day.svg": 5158,
	"./clear-night.svg": 2125,
	"./cloudy.svg": 5674,
	"./compass.svg": 8186,
	"./drizzle.svg": 6719,
	"./dust-day.svg": 9459,
	"./dust-night.svg": 7580,
	"./dust-wind.svg": 9691,
	"./dust.svg": 729,
	"./fahrenheit.svg": 8974,
	"./falling-stars.svg": 3052,
	"./fog-day.svg": 8629,
	"./fog-night.svg": 7938,
	"./fog.svg": 5274,
	"./hail.svg": 9536,
	"./haze-day.svg": 3931,
	"./haze-night.svg": 1067,
	"./haze.svg": 2045,
	"./horizon.svg": 9213,
	"./humidity.svg": 3650,
	"./hurricane.svg": 2116,
	"./lightning-bolt.svg": 4713,
	"./mist.svg": 8884,
	"./moon-first-quarter.svg": 7261,
	"./moon-full.svg": 2442,
	"./moon-last-quarter.svg": 3366,
	"./moon-new.svg": 6496,
	"./moon-waning-crescent.svg": 1185,
	"./moon-waning-gibbous.svg": 1238,
	"./moon-waxing-crescent.svg": 8403,
	"./moon-waxing-gibbous.svg": 9223,
	"./moonrise.svg": 9204,
	"./moonset.svg": 7975,
	"./not-available.svg": 9174,
	"./overcast-day.svg": 3088,
	"./overcast-night.svg": 9714,
	"./overcast.svg": 1250,
	"./partly-cloudy-day-drizzle.svg": 2911,
	"./partly-cloudy-day-fog.svg": 4411,
	"./partly-cloudy-day-hail.svg": 1345,
	"./partly-cloudy-day-haze.svg": 2450,
	"./partly-cloudy-day-rain.svg": 5141,
	"./partly-cloudy-day-sleet.svg": 6681,
	"./partly-cloudy-day-smoke.svg": 8176,
	"./partly-cloudy-day-snow.svg": 2047,
	"./partly-cloudy-day.svg": 6864,
	"./partly-cloudy-night-drizzle.svg": 9120,
	"./partly-cloudy-night-fog.svg": 9635,
	"./partly-cloudy-night-hail.svg": 3944,
	"./partly-cloudy-night-haze.svg": 8269,
	"./partly-cloudy-night-rain.svg": 9546,
	"./partly-cloudy-night-sleet.svg": 2705,
	"./partly-cloudy-night-smoke.svg": 6434,
	"./partly-cloudy-night-snow.svg": 5527,
	"./partly-cloudy-night.svg": 8628,
	"./pressure-high-alt.svg": 5084,
	"./pressure-high.svg": 9759,
	"./pressure-low-alt.svg": 3391,
	"./pressure-low.svg": 5716,
	"./rain.svg": 2946,
	"./raindrop.svg": 2069,
	"./raindrops.svg": 5696,
	"./sleet.svg": 3534,
	"./smoke-particles.svg": 9119,
	"./smoke.svg": 8110,
	"./snow.svg": 3716,
	"./snowflake.svg": 9918,
	"./solar-eclipse.svg": 2873,
	"./star.svg": 146,
	"./starry-night.svg": 3825,
	"./sunrise.svg": 8765,
	"./sunset.svg": 8913,
	"./thermometer-celsius.svg": 9894,
	"./thermometer-colder.svg": 6778,
	"./thermometer-fahrenheit.svg": 1459,
	"./thermometer-glass-celsius.svg": 7970,
	"./thermometer-glass-fahrenheit.svg": 2137,
	"./thermometer-glass.svg": 8776,
	"./thermometer-mercury-cold.svg": 8196,
	"./thermometer-mercury.svg": 9388,
	"./thermometer-warmer.svg": 5476,
	"./thermometer.svg": 5533,
	"./thunderstorms-day-rain.svg": 4421,
	"./thunderstorms-day-snow.svg": 6501,
	"./thunderstorms-day.svg": 1407,
	"./thunderstorms-night-rain.svg": 1129,
	"./thunderstorms-night-snow.svg": 5109,
	"./thunderstorms-night.svg": 3026,
	"./thunderstorms-rain.svg": 7199,
	"./thunderstorms-snow.svg": 1661,
	"./thunderstorms.svg": 604,
	"./tornado.svg": 4685,
	"./umbrella.svg": 8391,
	"./uv-index-1.svg": 6804,
	"./uv-index-10.svg": 4436,
	"./uv-index-11.svg": 8928,
	"./uv-index-2.svg": 7326,
	"./uv-index-3.svg": 9717,
	"./uv-index-4.svg": 6857,
	"./uv-index-5.svg": 1387,
	"./uv-index-6.svg": 4437,
	"./uv-index-7.svg": 2746,
	"./uv-index-8.svg": 6527,
	"./uv-index-9.svg": 8590,
	"./uv-index.svg": 4906,
	"./wind-beaufort-0.svg": 6,
	"./wind-beaufort-1.svg": 9335,
	"./wind-beaufort-10.svg": 9333,
	"./wind-beaufort-11.svg": 1965,
	"./wind-beaufort-12.svg": 8161,
	"./wind-beaufort-2.svg": 4242,
	"./wind-beaufort-3.svg": 9470,
	"./wind-beaufort-4.svg": 1174,
	"./wind-beaufort-5.svg": 2650,
	"./wind-beaufort-6.svg": 9102,
	"./wind-beaufort-7.svg": 1395,
	"./wind-beaufort-8.svg": 4139,
	"./wind-beaufort-9.svg": 7979,
	"./wind.svg": 2741,
	"./windsock.svg": 7644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7440;